import { render, staticRenderFns } from "./syncOrder.vue?vue&type=template&id=772909fd&scoped=true"
import script from "./syncOrder.vue?vue&type=script&lang=js"
export * from "./syncOrder.vue?vue&type=script&lang=js"
import style0 from "./syncOrder.vue?vue&type=style&index=0&id=772909fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772909fd",
  null
  
)

export default component.exports